module.exports = __webpack_public_path__ + "img/apple-download-logo.53ae045c.png";